export default defineNuxtPlugin({
  name: 'storyblok:cv',
  enforce: 'pre',
  parallel: true,
  dependsOn: ['storyblok:init'],

  async setup() {
    const cv = useState<number | false>('storyblok.cv', () => false);

    if (cv.value === false) {
      try {
        cv.value = import.meta.dev ? Date.now() : (await $fetch('/api/sb/cv.json')).cv || 0;
      } catch (e) {
        cv.value = Date.now();
        console.error(e);
      }
    }

    useStoryblokApi().setCacheVersion(cv.value || Date.now());
  },
});
